module.exports = __webpack_public_path__ + "img/noRecord.91b6d3cb.png";